<script>
import Drawer from "@/components/drawer.vue";

// Custom Components
import TicketForm from "@/components/superAdmin/pbxTicketForm.vue";
import PageHeader from "@/components/page-header.vue";
import TicketService from "@/helpers/APIService/ticket.service";
import middlewares from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import appConfig from "@/app.config";
import { authComputed } from "@/state/helpers";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "PBX Ticket",
      table: {
        tableData: [],
        totalPages: 1,
        pageNumber: 1,
        size: 50,
      },
      count: {
        all: 0,
        closed: 0,
        development: 0,
        new: 0,
        openL1: 0,
        openL2: 0,
        openL3: 0,
        waiting: 0,
      },
      isLoading: false,
      isShowTicketForm: false,
      ticketId: null,
      domain_uuid: null,
      buttonList: [
        {
          title: "All",
          value: "all",
          color: "info",
          count: 0,
        },
        {
          title: "New",
          value: "new",
          color: "success",
          count: 0,
        },
        {
          title: "L1",
          value: "openL1",
          color: "warning",
          count: 0,
        },
        {
          title: "L2",
          value: "openL2",
          color: "warning",
          count: 0,
        },
        {
          title: "L3",
          value: "openL3",
          color: "warning",
          count: 0,
        },
        {
          title: "Waiting",
          value: "waiting",
          color: "secondary",
          count: 0,
        },
        {
          title: "Development",
          value: "development",
          color: "secondary",
          count: 0,
        },
        {
          title: "Closed",
          value: "closed",
          color: "danger",
          count: 0,
        },
        {
          title: "My Tickets",
          value: "my_tickets",
          color: "primary",
        },
      ],
      selectedButton: {
        title: "New",
        value: "new",
        color: "success",
      },
    };
  },
  components: {
    PageHeader,
    Drawer,
    TicketForm,
  },
  computed: {
    ...authComputed,
  },
  async mounted() {
    if (this.$route.query.status == "my_ticket") {
      if (this.$route.query.domain_uuid) {
        await this.getTicketList(
          `?domain_uuid=${this.$route.query.domain_uuid}`
        );
        if (this.$route.query.domain_uuid) {
          this.table.tableData.forEach((element) => {
            if (element.status == "openL1") {
              this.count.openL1 += 1;
            }
            if (element.status == "openL2") {
              this.count.openL2 += 1;
            }
            if (element.status == "waiting") {
              this.count.waiting += 1;
            }
            if (element.status == "new") {
              this.count.new += 1;
            }
            if (element.status == "development") {
              this.count.development += 1;
            }
            if (element.status == "closed") {
              this.count.closed += 1;
            }
            this.count.all =
              this.count.closed +
              this.count.development +
              this.count.new +
              this.count.openL1 +
              this.count.openL2 +
              this.count.waiting;
          });
          this.buttonList = this.buttonList.map((item) => {
            if (Object.keys(this.count).find((key) => key == item.value)) {
              item.count = this.count[item.value];
            }
            return item;
          });
        }
        this.selectedButton = {
          title: "All",
          value: "all",
          color: "info",
          count: 0,
        };
      } else {
        await this.getTicketList(`?assign_to_user_uuid=${this.user.user.id}`);
        this.selectedButton = {
          title: "My Tickets",
          value: "my_tickets",
          color: "primary",
        };
      }
    } else {
      this.getTicketList("?status=new");
      this.getTicketCount();
    }
  },
  methods: {
    // Method is used to get ticket list
    async getTicketList(filter = "") {
      try {
        this.isLoading = true;
        const response = await TicketService.getTicketList(filter);
        if (response.status == false) {
          this.isLoading = false;
          return middlewares.notification(response.message, "warning");
        }
        this.table.tableData = response.result;
        this.table.pageNumber = response.page_number;
        this.table.totalPages = response.count;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        errorHandler(error);
      }
    },
    // Method is used to get ticket related count
    async getTicketCount(filter) {
      try {
        const response = await TicketService.getTicketCount(filter);
        if (response.status == false) {
          return middlewares.notification(response.message, "warning");
        }
        this.count = {
          ...response.result,
          all:
            response.result.closed +
            response.result.development +
            response.result.new +
            response.result.openL1 +
            response.result.openL2 +
            response.result.openL3 +
            response.result.waiting,
        };
        this.buttonList = this.buttonList.map((item) => {
          if (Object.keys(this.count).find((key) => key == item.value)) {
            item.count = this.count[item.value];
          }
          return item;
        });
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is used to edit ticket list
    editTicket(ticket) {
      this.$router.push(
        `/pbx-ticket-detail/${ticket.id}?domain_uuid=${ticket.domain_uuid}`
      );
    },
    // Method is used to edit ticket form
    editTicketForm() {
      this.isShowTicketForm = !this.isShowTicketForm;
    },
    // Method is used to submit form
    handleSubmit(data) {
      this.table.tableData.push(data);
      this.editTicketForm();
    },
    // Method is used to handle cancel ticket
    handleCancel() {
      this.editTicketForm();
    },
    // Method is use to get domain name
    getDomainName(domain_id) {
      let domain = "";
      if (localStorage.domain_list) {
        const domainList = JSON.parse(
          atob(localStorage.getItem("domain_list"))
        );
        domain = domainList.find((domain) => domain.id == domain_id);
      }
      return domain.domain_name;
    },
    // Method is used to filter ticket
    filterTicket(button_info) {
      this.selectedButton = button_info;
      if (button_info.value !== "my_tickets") {
        if (button_info.value == "all") {
          let query = "";
          if (this.$route.query.domain_uuid) {
            query += `?domain_uuid=${this.$route.query.domain_uuid}`;
          }
          return this.getTicketList(query);
        }
        let query = `?status=${button_info.value}`;
        if (this.$route.query.domain_uuid) {
          query += `&domain_uuid=${this.$route.query.domain_uuid}`;
        }
        this.getTicketList(query);
      } else {
        this.getTicketList(`?assign_to_user_uuid=${this.user.user.id}`);
      }
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :action="editTicketForm"
      text="Add New Ticket"
      :isButton="true"
    />
    <b-card>
      <div class="row align-items-center">
        <div class="col-xl-10 col-lg-9 col-md-9">
          <b-button
            :variant="
              btn.value == selectedButton.value
                ? `${btn.color}`
                : `outline-${btn.color}`
            "
            class="ticket-btn me-2 mb-2"
            v-for="(btn, index) in buttonList"
            :key="index"
            @click="filterTicket(btn)"
            >{{ btn.title }}
            <span v-if="btn.count !== undefined"
              >({{ btn.count }})</span
            ></b-button
          >
        </div>

        <div class="col-xl-2 col-lg-3 col-md-3">
          <div class="float-end text-primary">
            <router-link to="/tracking-reports"> Tracking Report </router-link>
            <i
              class="fas fa-sync ms-2"
              v-b-popover.hover="'Refresh'"
              @click="filterTicket(selectedButton)"
            ></i>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table mb-0">
          <thead class="table-light" slot="head">
            <tr>
              <th>TN</th>
              <th>Title</th>
              <th>Domain Name</th>
              <th>Caller Name</th>
              <th>Caller Number</th>
              <th>Status</th>
              <th>Priority</th>
              <th>Last Activity</th>
              <th>Assigned To</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody v-if="isLoading">
            <tr v-for="item in 20" :key="item">
              <td class="placeholder-glow" v-for="no in 10" :key="no">
                <span class="placeholder w-100 placeholder-lg"></span>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="(ticket, index) in table.tableData" :key="index">
              <td @click="editTicket(ticket)">#{{ ticket.ticket_number }}</td>
              <td @click="editTicket(ticket)">
                <div class="overflow-tip">
                  <span>
                    {{ ticket.ticket_title }}
                  </span>
                </div>
              </td>
              <td @click="editTicket(ticket)">
                {{ getDomainName(ticket.domain) }}
              </td>
              <td @click="editTicket(ticket)">
                {{ ticket.caller_name }}
              </td>
              <td @click="editTicket(ticket)">
                {{ ticket.caller_number }}
              </td>
              <td @click="editTicket(ticket)">
                <span
                  class="badge align-items-center py-1 px-2 card-badge text-capitalize"
                  :class="[
                    ticket.status === 'closed'
                      ? 'badge-soft-success'
                      : ticket.status === 'assigned'
                      ? 'badge-soft-danger'
                      : ticket.status === 'new'
                      ? 'badge-soft-secondary'
                      : ticket.status === 'development'
                      ? 'badge-soft-warning'
                      : ticket.status === 'openL1'
                      ? 'badge-soft-danger'
                      : ticket.status === 'openL2'
                      ? 'badge-soft-warning'
                      : ticket.status === 'openL3'
                      ? 'badge-soft-primary'
                      : ticket.status === 'waiting'
                      ? 'badge-soft-primary'
                      : 'badge-soft-secondary',
                  ]"
                >
                  {{ ticket.status }}
                </span>
              </td>
              <td @click="editTicket(ticket)">
                <span
                  class="badge align-items-center py-1 px-2 card-badge text-capitalize"
                  :class="[
                    ticket.priority === 'high'
                      ? 'badge-soft-warning'
                      : ticket.priority === 'urgent'
                      ? 'badge-soft-danger'
                      : ticket.priority === 'normal'
                      ? 'badge-soft-primary'
                      : 'badge-soft-secondary',
                  ]"
                >
                  {{ ticket.priority }}
                </span>
              </td>
              <td @click="editTicket(ticket)">
                {{ global_format_date(ticket.updated_at) }}
              </td>
              <td @click="editTicket(ticket)">
                {{
                  ticket.assign_to_user_name ? ticket.assign_to_user_name : "-"
                }}
              </td>
              <td>
                <i
                  class="fas far fa-eye text-success"
                  v-b-popover.hover="'view ticket detail'"
                  @click="editTicket(ticket)"
                ></i>
              </td>
            </tr>
          </tbody>
          <tbody v-if="!isLoading && table.tableData.length == 0">
            <tr>
              <td colspan="9" class="text-center">
                <img src="@/assets/images/empty.svg" class="img-fluid" alt="" />
                <p>
                  <span class="text-secondary">No Data Found</span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>
    <!-- Drawer is used to open pbx ticket form -->
    <Drawer
      @close="handleCancel"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="1000"
    >
      <div v-if="isShowTicketForm">
        <TicketForm
          :ticketId="this.ticketId"
          :domainId="this.domain_uuid"
          @cancelSubmit="handleCancel"
          @submitted="handleSubmit"
        />
      </div>
    </Drawer>
  </div>
</template>

<style scoped>
.ticket-btn {
  min-width: 70px;
}
</style>
